import React from 'react';
import './index.css';
import './App.css';
import Navbar from './component/Navbar';
import Hero from './component/Hero';
import About from './component/About';
import Work from './component/Work';
import Skills from './component/Skills';
import Contact from './component/Contact';
import Project from './component/Project';
import { Routes, Route } from 'react-router-dom';
import Homepage from './component/Homepage';
import CustomCursor from './component/CustomCursor';
import Detailproject from './component/ProjectDetail/Detailproject';

const App = () => {
  return (
    <div>
      <Navbar />

      <CustomCursor />

      <Routes>
        <Route path='/'  element={<Homepage/>} />
        <Route path="/Hero" element={<Hero />} />
        <Route path="/work" element={<Work />} />
        <Route path="/about" element={<About />} />
        <Route path="/project" element={<Project />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/contact" element={<Contact />} />
            <Route path="/detailproject/:name" element={<Detailproject />} />
      </Routes>
    </div>
  );
};

export default App;
